import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const NoteIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0.771431 17.2286L0.771431 18C0.345383 18 2.30563e-06 17.6546 2.26838e-06 17.2286L0.771431 17.2286ZM0.771429 0.771428L5.23115e-07 0.771429C5.05229e-07 0.566832 0.0812758 0.370616 0.225947 0.225946C0.370618 0.0812753 0.566833 1.78863e-08 0.771429 0L0.771429 0.771428ZM17.2286 0.771427L17.2286 -1.43873e-06C17.6546 -1.47598e-06 18 0.345377 18 0.771427L17.2286 0.771427ZM11.7429 11.7429L10.9714 11.7429C10.9714 11.3168 11.3168 10.9714 11.7429 10.9714L11.7429 11.7429ZM11.7429 17.2286L12.2883 17.7741L12.0624 18L11.7429 18L11.7429 17.2286ZM17.2286 11.7429L18 11.7429L18 12.0624L17.7741 12.2883L17.2286 11.7429ZM0.771431 17.2286L2.26838e-06 17.2286L5.23115e-07 0.771429L0.771429 0.771428L1.54286 0.771428L1.54286 17.2286L0.771431 17.2286ZM0.771429 0.771428L0.771429 0L17.2286 -1.43873e-06L17.2286 0.771427L17.2286 1.54285L0.771429 1.54286L0.771429 0.771428ZM11.7429 11.7429L12.5143 11.7429L12.5143 17.2286L11.7429 17.2286L10.9714 17.2286L10.9714 11.7429L11.7429 11.7429ZM11.7429 17.2286L11.7429 18L0.771431 18L0.771431 17.2286L0.771431 16.4571L11.7429 16.4571L11.7429 17.2286ZM17.2286 0.771427L18 0.771427L18 11.7429L17.2286 11.7429L16.4571 11.7429L16.4571 0.771427L17.2286 0.771427ZM17.2286 11.7429L17.2286 12.5143L11.7429 12.5143L11.7429 11.7429L11.7429 10.9714L17.2286 10.9714L17.2286 11.7429ZM17.2286 11.7429L17.7741 12.2883L12.2883 17.7741L11.7429 17.2286L11.1974 16.6831L16.6831 11.1974L17.2286 11.7429Z" fill={color} />
  </Svg>
);

NoteIcon.displayName = 'NoteIcon';
